import React, { useEffect, useMemo, useState } from "react";
import * as S from "./SurveyPatients.style";
import { useTranslation } from "react-i18next";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";
import * as P from "../../../../../../../utils/pipes";
import { v4 as uuidv4 } from 'uuid';
import { QUERY_GET_TYPE_SIDEEFFECTS } from "../../../../../../../graphql/queries/SideEffects";
import { useLazyQuery } from "@apollo/client";
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction";
import usePatientList from "../../../../../../../hooks/usePatientList";
import ZaiaImage from "../../../../../../zaiaComponents/zaiaImage";
import FlorenzButton from "../../../../../../florenzComponents/florenzButton";

// Assets
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;
const magnifyingGlass = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/magnifying-glass.svg`;
const noData = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;

function SurveyPatients({
  selectedPatientsList,
  changeFormField,
  patientId,
  processId,
  selectedProcess,
  inputSearchText
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const {patientList, patientListLoading, patientListError, patientQuantity } = usePatientList();
  
  useEffect(() => {
    // get patient with id patientId from patientList
    const patient = patientList?.find((patient) => patient.id === patientId);
    if(selectedPatientsList.value.length === 0 && patient) {
      addPatient(patient);
    }
  }, [patientId, patientList]);

  const getFilterText = (text) => {
    return inputSearchText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputSearchText).toLowerCase())
      : true
  }

  // const [ filterSymptoms, { data: symptomsData, error: symptomsError, loading: symptomsLoading }] = useLazyQuery(
  //   QUERY_GET_TYPE_SIDEEFFECTS
  // );

  const addPatient = (patient) => {
    const tempSymptomsList = JSON.parse(JSON.stringify(selectedPatientsList.value));
    const newPatient = {
      value: patient.id,
      text: `${patient.name} ${patient.lastname}`,
      image: patient.image
    }
    tempSymptomsList.push(newPatient);
    changeFormField(
      [
        {
          value: tempSymptomsList, 
          text: `(${tempSymptomsList.length})`, 
          fieldName: "patientsList"
        }
      ]
    )
  }
  
  const removePatient = (patient) => {
    const tempPatientsList = JSON.parse(JSON.stringify(selectedPatientsList.value));
    changeFormField(
      [
        {
          value: tempPatientsList.filter((item) => item.value !== patient.id), 
          text: `(${tempPatientsList.length - 1})`, 
          fieldName: "patientsList"
        }
      ]
    )
  }

  const removeAllPatients = () => {
    changeFormField(
      [
        {
          value: [], 
          text: `(${0})`, 
          fieldName: "patientsList"
        }
      ]
    )
  }

  const addAllPatients = () => {
    const tempPatientsList = JSON.parse(JSON.stringify(patientList));
    changeFormField(
      [
        {
          value: patientList.map((patient) => {
            return {
              value: patient.id,
              text: `${patient.name} ${patient.lastname}`,
              image: patient.image
            }
          }), 
          text: `(${tempPatientsList.length})`, 
          fieldName: "patientsList"
        }
      ]
    )
  }

  const  handleChangePatientsList = (patient, exist) => {
    if (exist) {
      removePatient(patient);
    } else {
      addPatient(patient);
    }
  }


  const existSymptom = (patient) => { 
    return selectedPatientsList?.value.find((item) => item.value === patient.id) ? true : false; 
  }  

  const getSymptomsList = () => {
    

    if (patientListError)
      return (
        <div className="zaia-reaction">
          <ZaiaReaction
            zaiaImg={logoZaiaAlert}
            text={"Error loading symptoms"}
            sizeText="20px"
            textColor="var(--blue-color)"
            widthimg="110px"
          />
        </div>
      )
    
    
    if (patientListLoading)
      return (
        <div className="zaia-reaction">
          <ZaiaReaction
            zaiaImg={logoZaiaLoading}
            sizeText="20px"
            textColor="var(--blue-color)"
            widthimg="110px"
          />
        </div>
      )

    if(patientQuantity === 0)
      return (
        <div className="empty-symptoms">
          <img src={noData} alt="" className="empty-symptoms__img" />
          <div className="empty-symptoms__title">
            No se encontraron resultados
          </div>
          <div className="empty-symptoms__subtitle">
            Zaia no puede encontrar ningún paciente que coincida con tu búsqueda
          </div>
        </div>
      )

    return(
      patientList?.filter((patient) => patient.userToProcesses.find((item) => item.process?.id === processId)).map((patient) => {
        const exist = existSymptom(patient);
        if(getFilterText(`${patient.name} ${patient.lastname}`)) {
          return (
            <S.ItemPatient
              key={uuidv4()}
              selected={exist}
            >
              <div 
                key={uuidv4()}
                className={`item`}
                onClick={() => handleChangePatientsList(patient, exist)}
              >
                <div className="item__left">
                  {
                    exist
                    ? <i class="item__icon icon zaia-i-checkbox-on"></i>
                    : <i class="item__icon icon zaia-i-checkbox-off"></i>
                  }
                  <ZaiaImage
                    img={patient.picture}
                    alt={`${patient.name} ${patient.lastname}`}
                    size={26}
                    rounded={true}
                  />
                  <div className="item__text">
                    <div 
                      className={`item__title`}
                    >
                      {`${patient.name} ${patient.lastname}`}
                    </div>
                    <div className={`item__subtitle`}>
                      {patient.email}
                    </div>
                  </div>
                </div>
              </div>
            </S.ItemPatient >
          )
        } else {
          return null
        }
      })
    )
  }

  return (
    <S.SurveyPatients
      searcher={inputSearchText}
    >
      <div className="surveys-list-header">
        <div className="surveys-list-header__title"></div>
        <div className="surveys-list-header__remove-selection">
          <FlorenzButton
            typeStyle={"secondary"}
            size="s"
            text={t("globally.all")}
            icon={selectedPatientsList?.value.length !== 0 ? "zaia-i-checkbox-on" : "zaia-i-checkbox-off"}
            iconSize={"20px"}
            onClick={() => 
              selectedPatientsList?.value.length === 0 
              ? addAllPatients()
              : removeAllPatients()
            }
          />
        </div>
      </div>
      <div className="patients-list">
        <div className={`patients-list__results ${inputSearchText === "" ?  "patients-list__results--hidden" : ""}`}>{t("globally.resultsFor")} "{inputSearchText}"</div>
        <div className="patients-list__container">
          {  
            getSymptomsList()
          }
        </div>
      </div>
      
    </S.SurveyPatients>
  );
}

export default SurveyPatients;
